/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Air
 * 
 * 1 = Sea
 * 
 * 2 = Road
 * 
 * 3 = Courier
 */
export enum TransportMode {
  Air = 0,
  Sea = 1,
  Road = 2,
  Courier = 3
}
